import { isStudioHostname } from '@/routing/studioHost';

const DEFAULT_PUBLIC_ORIGIN = 'https://lightshunt.com';

function parseOrigin(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const candidate = value.trim();

  if (!candidate || /^(undefined|null)$/i.test(candidate)) {
    return null;
  }

  try {
    const url = new URL(candidate);

    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return null;
    }

    return url.origin;
  } catch {
    return null;
  }
}

function isLocalOrPreviewOrigin(origin: string): boolean {
  const hostname = new URL(origin).hostname.toLowerCase();

  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    hostname === '::1' ||
    hostname.endsWith('.vercel.app')
  );
}

/**
 * Resolve the OAuth callback origin without turning a missing Vite variable
 * into the literal `undefined/auth/callback` URL.
 */
export function getOAuthCallbackOrigin(
  configuredOrigin: string | undefined = import.meta.env.VITE_APP_URL,
  currentOrigin: string | undefined =
    typeof window !== 'undefined' ? window.location.origin : undefined,
): string {
  const current = parseOrigin(currentOrigin);

  // The studio host keeps its own session, so OAuth must land back on it.
  if (current && (isLocalOrPreviewOrigin(current) || isStudioHostname(new URL(current).hostname))) {
    return current;
  }

  return parseOrigin(configuredOrigin) ?? current ?? DEFAULT_PUBLIC_ORIGIN;
}
